import { render } from "./ProcessingItem.vue?vue&type=template&id=2b497c5c&scoped=true&ts=true"
import script from "./ProcessingItem.vue?vue&type=script&lang=ts"
export * from "./ProcessingItem.vue?vue&type=script&lang=ts"

import "./ProcessingItem.vue?vue&type=style&index=0&id=2b497c5c&scoped=true&lang=css"

import exportComponent from "/builds/custom-client/enablewa-token-refresher/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b497c5c"]])

export default __exports__